export class GroupsModel{
  groupsCode ='' ;
  groupsName ='' ;
  groupsNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';
}
